export enum SidenavUtilitiesTabs {
  InfoPanel, // info panel is a specific report tab
  GlobalFilters, // common tab for applications
  SavedReports, // common tab for applications
  GlobalSearch, // common tab for applications
}
